import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Home from "./pages/HomePage";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import PrivateRoutes from "./utils/PrivateRoutes";
import ViewRecordDetails from "./pages/Details";
import Agent from "./pages/agent/Agent";
import Sidebar from "./components/Sidebar";
import Statistic from "./pages/Statistic";
import Availibility from "./pages/Availibility";
import AgentLogin from "./pages/agent/AgentLogin";
import AgentProfile from "./pages/agent/AgentProfile";
import Timesheet from "./pages/Timesheet";

function App() {
  return (
    <Router>
      <MainLayout />
    </Router>
  );
}

function MainLayout() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const noSidebarRoutes = ["/login", "/", "/agent-login"];
  const showSidebar = !noSidebarRoutes.includes(location.pathname);

  return (
    <div className="flex h-screen overflow-x-hidden">
      {showSidebar && (
        <>
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="fixed top-4 left-4 z-40 md:hidden p-2.5 rounded-lg bg-white border border-gray-200 shadow-sm text-gray-700 min-h-[44px] min-w-[44px] flex items-center justify-center"
            aria-label="Ouvrir le menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <Sidebar
            isMobileOpen={mobileMenuOpen}
            onMobileClose={() => setMobileMenuOpen(false)}
          />
        </>
      )}
      <div
        className={
          noSidebarRoutes.includes(location.pathname)
            ? "flex-1 w-full min-w-0 overflow-x-hidden"
            : "flex-1 w-full min-w-0 pt-14 md:pt-0 md:ml-60 overflow-x-hidden"
        }
      >
        <Routes>
          <Route element={<PrivateRoutes />}>
            <Route element={<Dashboard />} path="/dashboard" />
            <Route element={<Agent />} path="/agent" />
            <Route element={<Statistic />} path="/statistics" />
            <Route element={<Availibility />} path="/availability" />
            <Route element={<ViewRecordDetails />} path="/details/:id" />
            <Route element={<Timesheet />} path="/timesheet" />
          </Route>

          <Route element={<PrivateRoutes />}>
            <Route element={<AgentProfile />} path="/agent/profile" />
    
          </Route>

          
          <Route element={<Login />} path="/login" />
          <Route element={<AgentLogin />} path="/agent-login" />
          <Route element={<Home />} path="/" exact />
        </Routes>
      </div>
    </div>
  );
}

export default App;
